import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Hexagon, Menu, X } from "lucide-react";

const links = [
  ["/kreonis/markets", "Markets"],
  ["/kreonis/intelligence", "Intel Feed"],
  ["/kreonis/analyst", "Analyst"],
  ["/kreonis/simulation", "Simulation"],
  ["/kreonis/backtest", "Backtest"],
  ["/kreonis/pricing", "Pricing"],
];

export function KLogo() {
  return (
    <Link to="/kreonis" className="flex items-center gap-2" data-testid="kreonis-logo">
      <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-500/15 ring-1 ring-emerald-500/40">
        <Hexagon className="h-5 w-5 text-emerald-400" strokeWidth={2.4} />
      </div>
      <span className="font-display text-lg font-extrabold tracking-[0.2em] text-slate-100">KREONIS</span>
    </Link>
  );
}

export function KLayout({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      <header className="sticky top-0 z-50 border-b border-slate-800/80 bg-slate-950/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
          <div className="flex items-center gap-8">
            <KLogo />
            <nav className="hidden items-center gap-1 lg:flex">
              {links.map(([to, label]) => (
                <NavLink key={to} to={to} data-testid={`knav-${label.replace(/\s/g, "-").toLowerCase()}`}
                  className={({ isActive }) => `rounded-md px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-slate-800 text-slate-100" : "text-slate-400 hover:text-slate-100"}`}>
                  {label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-2">
            <ThemeToggle />
            <Link to="/register" data-testid="knav-request-access" className="rounded-md bg-emerald-500 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-emerald-400">Request Access</Link>
            <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="kreonis-menu">{open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}</button>
          </div>
        </div>
        {open && (
          <nav className="flex flex-col border-t border-slate-800 p-3 lg:hidden">
            {links.map(([to, label]) => <NavLink key={to} to={to} onClick={() => setOpen(false)} className="rounded-md px-3 py-2.5 text-sm text-slate-300 hover:bg-slate-800">{label}</NavLink>)}
          </nav>
        )}
      </header>
      <main>{children}</main>
      <footer className="mt-20 border-t border-slate-800/80 py-10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 text-xs text-slate-500 sm:flex-row sm:px-6">
          <KLogo />
          <div className="flex gap-4">
            <Link to="/kreonis/legal" className="hover:text-slate-300">Legal & Compliance</Link>
            <Link to="/kreonis/onboarding-email" className="hover:text-slate-300">Welcome Email</Link>
          </div>
          <span>© {new Date().getFullYear()} KREONIS · Institutional AI Market Intelligence · DEMO DATA</span>
        </div>
      </footer>
    </div>
  );
}

export function KBadge({ children }) {
  return <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1 text-xs font-medium text-emerald-300">{children}</span>;
}

export function KDemo() {
  return <span className="rounded bg-amber-500/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-400 ring-1 ring-amber-500/30">DEMO DATA</span>;
}
